import React from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

function validateDigitsOnly(evt) {
    var theEvent = evt || window.event;
    console.log(evt)

    // Handle paste
    if (theEvent.type === 'paste') {
        key = evt.clipboardData.getData('text/plain');
    } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
    }

    var regex = /^[0-9]*$/;
    if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
    }
}

export class Startup extends React.Component {
    constructor(props) {
        super(props);

        this.username = "";
        this.room = "";
        this.joinable = false;

        this.onPseudoChange = this.onPseudoChange.bind(this);
        this.onRoomChange = this.onRoomChange.bind(this);
        this.onJoinRequest = this.onJoinRequest.bind(this);
        this.onCreateRequest = this.onCreateRequest.bind(this);
    }

    onPseudoChange(e) {
        this.username = e.target.value;
        this.forceUpdate();
    }

    onRoomChange(e) {
        this.room = e.target.value
        this.forceUpdate();
    }

    onJoinRequest() {
        this.props.socket.send(JSON.stringify({ kind: "join", username: this.username.trim(), room: parseInt(this.room) }))
    }

    onCreateRequest() {
        this.props.socket.send(JSON.stringify({ kind: "create", username: this.username.trim() }))
    }

    render() {
        let alert = <div></div>;

        if (this.props.error != "") {
            alert = <Alert variant="danger">
                {this.props.error}
            </Alert>
        }

        return (<>
            <div class="h-100 text-center margin-auto">
                <Row><Col className={"title"}>motpal</Col></Row>
                <Row><Col className="alert">{alert}</Col></Row>
                <Row>
                    <Col>
                        <Form>
                            <Form.Label>Choisissez un pseudonyme</Form.Label>
                            <Form.Control type="text" className="center-field text-center" onChange={this.onPseudoChange} maxLength="20" />
                            <hr class="divider" />
                            <Form.Group controlId="join">
                                <Row><Col>
                                    <Form.Label>Rejoindre une partie</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="center-field code-field"
                                        maxLength="6"
                                        onChange={this.onRoomChange}
                                        onKeyPress={validateDigitsOnly}
                                        onPaste={validateDigitsOnly}
                                    />
                                    <Form.Text className="text-muted center-field">
                                        Le créateur de la partie doit vous communiquer un code de salon
                                    </Form.Text>
                                </Col></Row>

                                <Row><Col>
                                    <Button disabled={this.username == "" || this.room.length != 6} variant="success" onClick={this.onJoinRequest} className="mt-3">
                                        Rejoindre
                                    </Button>
                                </Col></Row>
                            </Form.Group>
                            <hr class="divider" />
                            <Form.Group controlId="new">
                                <Row><Col>
                                    <Form.Label>Nouvelle partie</Form.Label>
                                </Col></Row>
                                <Row><Col>
                                    <Button disabled={this.username.trim() == ""} variant="primary" onClick={this.onCreateRequest}>
                                        Créer une nouvelle partie
                                    </Button>
                                </Col></Row>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
            </div>
        </>);
    }
}